import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=479a154a&scoped=true&"
import script from "./userList.vue?vue&type=script&lang=js&"
export * from "./userList.vue?vue&type=script&lang=js&"
import style1 from "./userList.vue?vue&type=style&index=1&id=479a154a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a154a",
  null
  
)

export default component.exports